import EmployeeListPage from './list'
export default EmployeeListPage
